import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import { Typography, Flex, Button, Tag, Select, Input } from "antd";
import Layout from "../layout/Layout";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
import {
	DownloadOutlined,
	EditFilled,
	PlusCircleFilled,
} from "@ant-design/icons";
import { franchises57Options } from "../../constants/Customer";
import { CSVLink } from "react-csv";
import { useRef } from "react";

const { Text } = Typography;
const { Search } = Input;

const statusOptions = [
	{
		value: "All",
		label: "All",
	},
	{
		value: "Active",
		label: "Active",
	},
	{
		value: "Inactive",
		label: "Inactive",
	},
];

const ForemanList = ({ history }) => {
	const [loading, setLoading] = useState(true);
	const [foremanList, setForemanList] = useState([]);
	const [franchise, setFranchise] = useState("57Concrete");
	const [term, setTerm] = useState("");
	const [status, setStatus] = useState("All");
	const refDownload = useRef();

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "",
			dataIndex: "edit",
			width: 100,
			render: (_, record) => {
				return (
					<Flex justify="space-between">
						{localStorage.getItem("email") === "ec@57concrete.com" ||
						localStorage.getItem("email") === "pc@57concrete.com" ||
						localStorage.getItem("email") === "jc@57concrete.com" ||
						localStorage.getItem("email") === "gg@57xgroup.com" ||
						localStorage.getItem("email") === "eliud@gmail.com" ? (
							<Button
								type="primary"
								icon={<EditFilled twoToneColor={"white"} />}
								onClick={(e) => history.push(`/foreman/${record.id}`)}
							/>
						) : (
							""
						)}
					</Flex>
				);
			},
		},
		{
			title: "Name",
			dataIndex: "name",
			key: "name",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Email",
			dataIndex: "email",
			key: "corporateSales",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Phone",
			dataIndex: "phone",
			key: "phone",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Address",
			dataIndex: "address",
			key: "address",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Is Active?",
			dataIndex: "active",
			render: (value) => {
				return (
					<Tag color={value ? "green" : "red"}>
						{value ? "Active" : "Inactive"}
					</Tag>
				);
			},
		},
		{
			title: "Franchise",
			dataIndex: "franchise",
			key: "franchise",
			render: (value) => {
				return (
					<Tag color={value === "57Concrete" ? "green" : "cyan"}>{value}</Tag>
				);
			},
		},
	];

	useEffect(() => {
		getForemanList();
	}, [term, franchise, status]);

	const getForemanList = async () => {
		setLoading(true);

		const url =
			api + `/foreman/list/search/${franchise}?term=${term}&status=${status}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [];
			data.map((item, index) => {
				list.push({
					key: index,
					id: item._id,
					name: `${item.firstName} ${item.lastName}`,
					email: item.email,
					phone: item.phone,
					address: item.address,
					franchise: item.franchise || "57Concrete",
					active: item.active,
				});
			});
			setForemanList(list);
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const addNewForeman = () => {
		history.push("/foreman/new");
	};

	const headers = () => {
		return columns.slice(1).map((item) => {
			return {
				key: item.dataIndex,
				label: item.title,
			};
		});
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<Flex gap={"large"}>
					{(localStorage.getItem("email") === "ec@57concrete.com" ||
						localStorage.getItem("email") === "pc@57concrete.com" ||
						localStorage.getItem("email") === "jc@57concrete.com" ||
						localStorage.getItem("email") === "gg@57xgroup.com" ||
						localStorage.getItem("email") === "eliud@gmail.com") && (
						<Button
							onClick={addNewForeman}
							type="primary"
							style={{
								width: 150,
							}}
							icon={<PlusCircleFilled />}
							size={"large"}
						>
							New Foreman
						</Button>
					)}
					{(localStorage.getItem("email") === "ec@57concrete.com" ||
						localStorage.getItem("email") === "jp@57concrete.com" ||
						localStorage.getItem("email") === "vc@57concrete.com" ||
						localStorage.getItem("email") === "eliud@gmail.com") && (
						<div>
							<CSVLink
								data={foremanList}
								headers={headers()}
								filename={"57concrete-foreman-list.csv"}
								hidden
								ref={refDownload}
							>
								Download CSV
							</CSVLink>
							<Button
								size="large"
								type="primary"
								onClick={(e) => refDownload.current.link.click()}
								loading={loading}
								icon={<DownloadOutlined />}
							>
								Download Foreman List
							</Button>
						</div>
					)}
				</Flex>
				<CustomTable columns={columns} data={foremanList} />
			</Flex>
		);
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const RenderSearch = () => {
		return (
			<Flex gap={"large"}>
				<Select
					showSearch
					placeholder={`Select status`}
					optionFilterProp="children"
					size="large"
					onChange={(value) => setStatus(value)}
					filterOption={filterOption}
					options={statusOptions}
					disabled={loading}
					defaultValue={"All"}
					value={status}
					style={{
						width: 200,
					}}
					allowClear={false}
				/>
				<Select
					showSearch
					placeholder={`Select franchise`}
					optionFilterProp="children"
					size="large"
					onChange={(value) => setFranchise(value)}
					filterOption={filterOption}
					options={franchises57Options}
					disabled={loading}
					defaultValue={"57Concrete"}
					value={franchise}
					style={{
						width: 200,
					}}
					allowClear={false}
				/>
				<Search
					placeholder="Search"
					enterButton
					onSearch={(value) => setTerm(value)}
					allowClear
					style={{
						width: 400,
					}}
					size="large"
					loading={loading}
					disabled={loading}
				/>
			</Flex>
		);
	};

	return (
		<Layout title="Foreman" description="Foreman List">
			<Flex vertical gap={"large"}>
				<RenderSearch />
				{loading ? <CustomSpinner /> : <RenderTable />}
			</Flex>
		</Layout>
	);
};

export default ForemanList;
